import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getUserCollectionId } from '../../../../../_augmentt/selectors/userPermissions'
import useCustomerOptions from '../../../../hooks/useCustomerOptions'

/**
 * Company and collection options shared by the company access fields and the form's initial values.
 */
const useCompanyAccessOptions = ({ allCustomers, customerCollections }) => {
  const currentUserCollectionId = useSelector(getUserCollectionId)
  const customerOptions = useCustomerOptions(allCustomers)

  const collectionOptions = useMemo(
    () => customerCollections.map((item) => ({ label: item.owner.name, value: item.id })),
    [customerCollections],
  )

  const collectionMap = useMemo(() => {
    const result = {}
    customerCollections.forEach((item) => {
      result[item.id] = item
    })
    return result
  }, [customerCollections])

  const allCustomersIds = useMemo(() => allCustomers?.map((customer) => customer.id), [allCustomers])

  const allNonNfrCustomersIds = useMemo(
    () =>
      allCustomers
        ?.filter((customer) => {
          if (currentUserCollectionId) {
            return customer.id !== collectionMap[currentUserCollectionId]?.owner?.id
          }

          return !!customer.parent_id
        })
        ?.map((customer) => customer.id),
    [allCustomers, currentUserCollectionId, collectionMap],
  )

  return useMemo(
    () => ({
      currentUserCollectionId,
      customerOptions,
      collectionOptions,
      collectionMap,
      allCustomersIds,
      allNonNfrCustomersIds,
    }),
    [
      currentUserCollectionId,
      customerOptions,
      collectionOptions,
      collectionMap,
      allCustomersIds,
      allNonNfrCustomersIds,
    ],
  )
}

export default useCompanyAccessOptions
